import { Component, OnInit  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UserInfo } from '../../models/account/userInfo';
import { Parameter } from '../../models/account/parameter';

import { AccountService } from '../../services/account/account.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'profile',
    template: require('./../../templates/account/profileView.component.html'),
    styles: [require('./../../styles/account/profileView.component.css')],
    providers: [AccountService, ToastrService]
})
export class ProfileViewComponent implements OnInit {
    userInfo: UserInfo = {
        isAuthenticated: false,
        userName: '',
        name: '',
        email: '',
        claims: new Array<Parameter>(),
        is2FAEnabled: false,
        is2FARequired: false
    };
    errorMessage: string = "";
    formSuccessReason: string = "";
    formFailReason: string = "";
    isAuthenticated: boolean = false;
    pairingUri : string = "";

    constructor(private accountService: AccountService, private toastr: ToastrService) {
        this.isAuthenticated = false;
    }

    ngOnInit() {
        this.loadUserInfo();
    }

    private loadUserInfo() {
        this.accountService.isAuthenticated(userInfo => {
            this.userInfo = userInfo;
            this.isAuthenticated = userInfo.isAuthenticated;
            if (!userInfo.is2FAEnabled) {
                this.accountService.getTwoFactorAuthenticationPairingParameters().subscribe(response => {
                    this.pairingUri = response.data.pairingUri2FA;
                });
            }
        });
    }

    onOtpChange(e:string) {
        if (e.length === 6) {
            // pair
            this.accountService.pairTwoFactorAuthenticationDevice(e)
                .subscribe(response => {
                    if (response.success) {
                        this.loadUserInfo();
                        this.toastr.success("Paired successfully", "Success", {closeButton: true});
                    }
                });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/account/profileView.component.ts